import { render, staticRenderFns } from "./addrPopup.vue?vue&type=template&id=c09575f2&scoped=true"
import script from "./addrPopup.vue?vue&type=script&lang=ts"
export * from "./addrPopup.vue?vue&type=script&lang=ts"
import style0 from "./addrPopup.vue?vue&type=style&index=0&id=c09575f2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09575f2",
  null
  
)

export default component.exports